import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import "../../../../../../../styles/shared/manage-services.css";
import IconButton from "@mui/material/IconButton";
import { FaRegTimesCircle } from "react-icons/fa";
import { updateServiceStatus } from "../../../../../../../services/ShipperServices/Carriers/carriers.services";
import { useParams } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";

export default function ManageServices({
  open,
  setOpen,
  carrier,
  Android12Switch,
  setCarriers,
  setSnack,
}) {
  const { t } = useTranslation("settings");
  const [data, setData] = useState({});
  const handleOpen = () => setOpen(true);
  const { plugin } = useParams();
  const handleClose = () => {
    setOpen(false);
  };
  const handleServiceChange = async (e, service) => {
    setData((data) => {
      return {
        ...data,
        services: {
          ...data.services,
          [plugin]: { ...data.services?.[plugin], [service]: e.target.checked },
        },
      };
    });
    const response = await updateServiceStatus(
      { [service]: e.target.checked, type: plugin },
      data?.id
    );
    if (!response.error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t(
            e.target.checked
              ? "plugins.serviceEnabled"
              : "plugins.serviceDisabled",
            { service },
          ),
          severity: "success",
        };
      });
      setCarriers((prevState) => {
        return {
          ...prevState,
          data: prevState?.data?.map((carr) => {
            if (carr.id === data.id) {
              return {
                ...data,
                services: {
                  ...data.services,
                  [plugin]: {
                    ...data.services?.[plugin],
                    [service]: e.target.checked,
                  },
                },
              };
            } else {
              return carr;
            }
          }),
        };
      });
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("messages.somethingWentWrong"),
          severity: "error",
        };
      });
      setData((data) => {
        return {
          ...data,
          services: {
            ...data.services,
            [plugin]: {
              ...data?.services?.[plugin],
              [service]: !e.target.checked,
            },
          },
        };
      });
    }
  };
  useEffect(() => {
    if (carrier) {
      setData(carrier);
      // console.log(carrier);
    }
  }, [carrier]);

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className="manage__services_modal">
          <div className="manage__services_closewrap" onClick={handleClose}>
            <IconButton>
              <FaRegTimesCircle size={25} color="lightgrey" />
            </IconButton>
          </div>
          <div className="manage__services_modalheader">
            <h2>
              <Trans
                t={t}
                i18nKey="plugins.servicesTitle"
                values={{ name: carrier?.name ? `${carrier?.name} ` : "" }}
                components={{
                  name: <span className="manage__services_mhheadingcarr" />,
                }}
              />
            </h2>
            <img
              className="manage__services_modalhdrimg"
              src={data?.shipping_company_for_user?.logo_url}
            />
          </div>
          <div className="manage__services_modalcontent">
            <div className="manage__services_srvcsgrid">
              {data?.services?.[plugin] &&
                Object.entries(data?.services?.[plugin])?.map(
                  ([service, status]) => {
                    return (
                      <div>
                        <div className="manage__services_srvcsgitem">
                          <Android12Switch
                            onChange={(e) => handleServiceChange(e, service)}
                            checked={status}
                          />
                          <span className="manage__services_srvcsgitxt">
                            {service.toUpperCase()}
                          </span>
                        </div>
                      </div>
                    );
                  }
                )}
            </div>
            {(data?.services?.length < 1 || !data?.services) && (
              <div className="manage__services_srvcsempt">
                {t("plugins.noServices")}
              </div>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
}
